import { put } from 'redux-saga/effects';
import { authenticate } from 'auth/actions';
import { account } from 'app/routes';

export function* accountNavigate() {
  yield put(authenticate(account()));
}
